import { createAuthClient } from 'better-auth/react'
import { env } from './env.js'

/**
 * Better Auth client for the SPA.
 *
 * Auth is COOKIE-based: the API sets an HttpOnly session cookie scoped to the
 * shared parent domain (.brightstars.in via crossSubDomainCookies in the API's
 * auth.ts), so the browser sends it automatically to the API subdomain on every
 * request made with `credentials: 'include'`. This works for both email/password
 * and the Google OAuth redirect flow (the redirect can't hand a bearer token
 * back to the SPA, but it does set the cookie).
 *
 * `fetchOptions.credentials: 'include'` ensures the better-auth client itself
 * sends/receives the cookie cross-subdomain. The app's API client (lib/api.ts)
 * sets the same flag on its own fetches.
 */
export const authClient = createAuthClient({
  baseURL: `${env.API_URL}/api/auth`,
  fetchOptions: {
    credentials: 'include',
  },
})

/**
 * Session check usable outside React (e.g. TanStack Router `beforeLoad`).
 * Returns true if the cookie identifies a valid Better Auth session.
 */
export async function hasSession(): Promise<boolean> {
  const { data } = await authClient.getSession({
    fetchOptions: { credentials: 'include' },
  })
  return !!data?.user
}
